var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUricMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#B3E2D7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6109 20.6651C11.5925 20.7023 11.5741 20.7395 11.5372 20.7953C10.7261 22.2093 8.90109 22.693 7.48164 21.8744C6.0622 21.0558 5.5829 19.2512 6.39402 17.8186C6.41245 17.7814 6.44932 17.7442 6.46775 17.707L6.52306 17.5953L13.8046 5L18.9478 7.95814L11.6662 20.5535L11.6109 20.6651ZM15.2794 21.2791V25H14.3576V21.2791C14.3576 18.5256 17.1228 18.4884 17.1228 18.4884C17.1228 18.4884 17.4362 18.6 17.5837 18.9535C17.7311 19.307 17.5837 19.4186 17.5837 19.4186C17.5837 19.4186 15.2794 19.1023 15.2794 21.2791ZM23.9988 18.4884C23.9435 21.6884 21.6761 23.5302 20.6069 23.8093C19.5377 24.0884 17.8233 23.6419 17.6021 21.9116C17.4177 20.4977 18.0261 20.293 18.3579 19.2512C18.5422 18.6744 18.2289 17.9674 17.6021 17.7256C17.6021 17.7256 16.2011 16.9442 16.4776 15.4372C16.7357 13.9302 18.3026 12.8884 20.2382 13.1488C22.1738 13.4465 24.0541 15.2884 23.9988 18.4884Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUricMark);
export default __webpack_public_path__ + "static/media/uric_mark.ab7f065433441dfceefd322eb98a96c4.svg";
export { ForwardRef as ReactComponent };